module.exports = __webpack_public_path__ + "static/media/source-sans-pro-v11-latin-regular.76d8cbb0.woff2";